import React from "react";

const NeueChevronRightRegularIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.2 10.8L18.8 16L13.2 21.2",
  stroke: "currentColor",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(NeueChevronRightRegularIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;